import { useMemo, useState } from "react";
import { groupBy, uniq } from "lodash";
import { useHead } from "../services/common";
import { Galleries, useGalleries } from "../components/Gallery";
import moment from "moment";
import { Loading } from "../components";

export default function Gallery() {

    useHead({
        title: "Fotogalerie | T.J. Sokol Poniklá",
        description: "Prohlédněte si fotografie z našich akcí, sportovních utkání, tréninků a společenských událostí T.J. Sokol Poniklá."
    });

    const [galleries, error, isLoading, reload] = useGalleries();

    const groups = useMemo(() => {
        if (!galleries) return [moment().format("YYYY")];

        return uniq(Object.keys(groupBy(galleries, event => moment(event.date).format("YYYY"))))
            .sort()
            .reverse();
    }, [galleries]);

    const [activeGroup, setActiveGroup] = useState(groups[0]);

    const showGalleries = (galleries || []).filter(event => moment(event.date).format("YYYY") === activeGroup);

    return <>
        <div className="header">
            <h1>Fotogalerie</h1>
        </div>
        <section className="width-max">
            {isLoading && <Loading />}
            {error && <p className="alert">Fotogalerii se nepodařilo načíst. Zkuste to prosím později.</p>}
            {galleries && <>
                {showGalleries.length === 0 && <p className="info">Zatím zde nejsou žádné galerie.</p>}
                <div className="button-select width-max">
                    {groups.map(group => <button key={group} className={activeGroup === group ? "active" : ""} onClick={() => setActiveGroup(group)}>{group}</button>)}
                </div>
                <Galleries galleries={showGalleries} year={Number(activeGroup)} onChange={reload} />
            </>}
        </section>
    </>;
}